
import {
  Component,
  Vue,
  Prop,
  Model,
  Emit,
  Watch
} from "vue-property-decorator";
import ModalHeader from "@/components/modal-header.vue";
import ModalTitle from "@/lib/model/exam/modal-title";
import Auth from "@/lib/common/auth";
import Candidate, {
  CandidateList,
  CandidateMAudit
} from "@/lib/model/exam/candidate";

class AuditArr {
  // 候选人评估数量类
  await = 0;
  passed = 0;
  pending = 0;
  refused = 0;
  unfinish = 0;
}

@Component({
  components: {
    ModalHeader
  }
})
export default class AuditCandidate extends Vue {
  name = "audit-candidate";
  @Prop() selectedIdList!: number[];
  @Prop() auditArr!: AuditArr;
  @Prop() multiAudit!: boolean;
  auditStatus = 1;
  auditDesc = "";
  candidateMAuditForm = new CandidateMAudit();

  modalTitle: ModalTitle = new ModalTitle();
  selectNum = 1;
  isVisible = true;

  mounted() {
    console.log("1111111", this.auditArr);
    this.modalTitle.title =
      "给出评估结果（已选" + this.selectedIdList.length + "人）";
    this.modalTitle.hasDesc = false;
  }

  handleClose() {
    this.auditCancel();
  }

  @Emit("on-submit-audit")
  hideAuditModal() {
    console.log("on-submit-audit");
  }

  auditSubmit() {
    if (
      this.auditArr.passed > 0 ||
      this.auditArr.pending > 0 ||
      this.auditArr.refused > 0 ||
      this.auditArr.await > 0
    ) {
      this.candidateMAuditForm.companyId = parseInt(Auth.companyId);
      const candidateLists = new Array<CandidateList>();
      this.selectedIdList.forEach((item, index) => {
        const temparr = new CandidateList();
        temparr.candidateId = item;
        temparr.auditStatus = this.auditStatus;
        temparr.auditDesc = this.auditDesc;
        candidateLists.push(temparr);
        // candidateLists[index].candidateId = item;
        // candidateLists[index].auditStatus = this.auditStatus;
        // candidateLists[index].auditDesc = this.auditDesc;
      });
      this.candidateMAuditForm.candidateList = candidateLists;
      Candidate.mAuditCandidate(this.candidateMAuditForm)
        .then(resp => {
          if (resp.code === 0) {
            this.$message.success("评估成功");
          } else {
            this.$message.error(resp.message);
          }
        })
        .then(() => {
          this.hideAuditModal();
        });
    } else {
      this.$message.error("没有需要评估的候选人");
    }
  }

  @Emit("on-cancel-audit")
  auditCancel() {
    console.log("on-cancel-audit");
  }
}
